// This has the same functionality as useHydration (https://nuxt.com/docs/api/composables/use-hydration#usehydration)
// except it doesn't hydrate on 'app:created' hook, but immediately after using it. This makes it suitable fo use in
// async components that are created well after 'app:created' has already fired.
export default function useImmediateHydration<T>(key: string, get: () => T, set: (value: T) => void) {
	const nuxt = useNuxtApp();

	if (import.meta.server) {
		nuxt.hooks.hook('app:rendered', () => {
			// Only write once; avoids keeping unnecessary closures
			if (!(key in nuxt.payload)) {
				nuxt.payload[key] = get();
			}
		});
	}

	if (import.meta.client) {
		if (key in nuxt.payload) {
			set(nuxt.payload[key] as any);

			// Delete payload after hydration to free memory
			delete nuxt.payload[key];
		}

		// Clear reactive state when component unmounts
		onUnmounted(() => {
			set(null as unknown as T);
		});
	}
}
